import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import PollView from '../PollView';
export default class PollShowcaseItem extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "poll", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.poll = this.attrs.poll;
  }
  view() {
    return m("div", {
      className: "PollShowcase--item"
    }, m(PollView, {
      poll: this.poll
    }));
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollShowcaseItem', PollShowcaseItem);